<div
  [ngClass]="
    checkExpertType == 'document' || exportTypeValue == 'document'
      ? 'increaseHeightDocxCont'
      : 'decreaseHeightDocxCont'
  "
  class="container-fluid prefHeight preferences"
>
  <div class="source-container ml-lg-3">
    <div class="row no-margin">
      <div class="col-md-9 col-lg-9 col-xl-9 margin-test-preferences">
        <div class="row no-margin fontSize18">
          <h1 class="test-preferences fontSize18">Test Preferences</h1>
        </div>
      </div>
    </div>
    <div class="row no-margin padding-top">
      <div class="col-md-9 col-lg-9 col-xl-9 preferncesMinHeight">
        <div class="col-md-12 col-lg-12 col-xl-12 mt-2">
          <div class="row">
            <div class="col-md-3 mt-1">
              <h2 id="exportAsSectionHeading">Export As:</h2>
            </div>
            <div class="ahe-ui-radio-list" role="radiogroup" aria-labelledby="exportAsSectionHeading">
              <div class="qtiTypes">
                <label class="ahe-ui-radio pb-0">
                  <input
                    type="radio"
                    name="qtiType"
                    id="export-as-blackboard-canvas"
                    [(ngModel)]="exportTypeValue"
                    value="MH"
                    [checked]="defaultCheckObject.MH"
                    (change)="prefChanges($event)"
                    aria-describedby="qtiTypeSubtitle"
                    aria-labelledby="label-for-export-as-blackboard-canvas"
                  />
                  <span id="label-for-export-as-blackboard-canvas">D2L/Blackboard/Canvas (Classic Quiz Only)/Moodle </span>
                </label>
                <div id="qtiTypeSubtitle" class="ahe-ui-radio pt-0 subtitle">
                  Use Blackboard Ultra or D2L as the content type for
                  importing "Classic Quizzes" into Canvas
                </div>
                <label class="ahe-ui-radio">
                  <input
                    type="radio"
                    name="qtiType"
                    id="canvasQTI"
                    [(ngModel)]="exportTypeValue"
                    value="canvas"
                    [checked]="defaultCheckObject.canvas"
                    (change)="prefChanges($event)"
                    aria-labelledby="label-for-canvasQTI"
                  />
                  <span id="label-for-canvasQTI">Canvas QTI (New Quiz Only)</span>
                </label>
              <label class="ahe-ui-radio">
                <input
                  type="radio"
                  name="qtiType"
                  id="qti-document"
                  [checked]="defaultCheckObject.document"
                  value="document"
                  (change)="prefChanges($event)"
                  [(ngModel)]="exportTypeValue"
                  aria-labelledby="label-for-qti-document"
                />
                <span id="label-for-qti-document">DOCX</span>
              </label>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="exportTypeValue == 'document' || checkExpertType == 'document'"
          class="col-md-12 col-lg-12 col-xl-12"
        >
          <div class="mt-4 line-divider">
            <div class="row padding-top-bottom">
              <div class="fontSize18 mt-2 pt-4 col-md-12 col-lg-12">
                <h2 id="scrambleSectionHeading">Scramble</h2>
              </div>
              <div class="ml-3 row padding-top-bottom row">
                <div
                  class="ahe-ui-radio-list align-vertical"
                  role="radiogroup" aria-labelledby="scrambleSectionHeading"
                >
                  <label class="ahe-ui-radio">
                    <input
                      type="radio"
                      id="doNotScramble"
                      name="scramble"
                      value="doNotScramble"
                      (change)="prefChanges($event)"
                      [(ngModel)]="scramblePref"
                      aria-labelledby="label-for-doNotScramble"
                    />
                    <span id="label-for-doNotScramble"> Don't scramble questions </span>
                  </label>
                  <label class="ahe-ui-radio">
                    <input
                      type="radio"
                      id="scrambleQuestions"
                      name="scramble"
                      value="scrambleQuestions"
                      (change)="prefChanges($event)"
                      [(ngModel)]="scramblePref"
                      aria-labelledby="label-for-scrambleQuestions"
                    />
                    <span id="label-for-scrambleQuestions">Scramble questions only </span>
                  </label>
                  <label class="ahe-ui-radio">
                    <input
                      type="radio"
                      id="scrambleAnswerOptions"
                      name="scramble"
                      value="scrambleAnswerOptions"
                      (change)="prefChanges($event)"
                      [(ngModel)]="scramblePref"
                      aria-labelledby="label-for-scrambleAnswerOptions"
                    />
                    <span id="label-for-scrambleAnswerOptions">Scramble answers only </span>
                  </label>
                  <label class="ahe-ui-radio">
                    <input
                      type="radio"
                      id="scrambleDistractors"
                      name="scramble"
                      value="scrambleDistractors"
                      (change)="prefChanges($event)"
                      [(ngModel)]="scramblePref"
                      aria-labelledby="label-for-scrambleDistractors"
                    />
                    <span id="label-for-scrambleDistractors">Scramble questions and answer options
                    </span>
                  </label>
                </div>
                <div class="mt-2 ml-3 col-md-12 col-lg-12">
                  <label for="versions"># of versions (max 20) <app-required-indicator [required]="!disableVersion"></app-required-indicator></label>
                  <div class="ahe-ui form-group no-margin d-flex flex-column mb-2">
                    <input
                      class="mt-2 mb-2 mr-2 textWidth form-control"
                      type="text"
                      maxlength="2"
                      id="versions"
                      [value]="noOfVersions"
                      (change)="prefChanges($event)"
                      [disabled]="disableVersion"
                      aria-describedby="versionsHint"
                      (focusout)="validateNumber($event, 20)"
                      [required]="!disableVersion"
                    />
                    <span id="versionsHint" class="input-hint">
                      <span aria-hidden="true">(</span>Enter a value between 1 and 20<span aria-hidden="true">)</span>
                    </span>
                  </div>
                </div>
                <div class="col-md-12 col-lg-12">
                  <label class="ahe-ui-checkbox">
                    <input
                      type="checkbox"
                      id="lockedAlgo"
                      [(ngModel)]="lockedAlgo"
                      [value]="lockedAlgo"
                      (change)="prefChanges($event)"
                      [disabled]="disableAlgo"
                      aria-labelledby="label-for-lockedAlgo"
                    />
                    <span
                      class="cursor-pointer"
                      id="label-for-lockedAlgo"
                    >Algorithmic questions - print same iteration for all
                      students</span
                    >
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="line-divider">
            <div class="fontSize18 mt-3 pt-4 pb-4 padding-row-bottom">
              <h2>Appearance</h2>
            </div>
            <div>
              <div class="row pb-4">
                <div class="col-lg-4">
                  <div class="row ahe-ui form-group mt-2 ml-2 no-margin">
                    <h3 id="layoutSectionHeading">Layout</h3>
                  </div>
                  <div class="ahe-ui-radio-list align-vertical" role="radiogroup" aria-labelledby="layoutSectionHeading">
                    <label class="ahe-ui-radio">
                      <input
                        type="radio"
                        id="oneColumn"
                        name="layout"
                        value="oneColumn"
                        (change)="prefChanges($event)"
                        [(ngModel)]="columnPref"
                        aria-labelledby="label-for-oneColumn"
                      />
                      <span aria-hidden="true"></span>
                      <img
                        [src]="oneColumnImgUrl"
                        title="One Column"
                        alt="One Column"
                        class="ml-3"
                        aria-hidden="true"
                      />
                      <span id="label-for-oneColumn" class="ml-3">One Column</span>
                    </label>
                    <label class="ahe-ui-radio">
                      <input
                        type="radio"
                        id="twoColumn"
                        name="layout"
                        value="twoColumn"
                        (change)="prefChanges($event)"
                        [(ngModel)]="columnPref"
                        aria-labelledby="label-for-twoColumn"
                      />
                      <span aria-hidden="true"></span>
                      <img
                        [src]="twoColumnImgUrl"
                        title="Two Column"
                        alt="Two Column"
                        class="ml-3"
                        aria-hidden="true"
                      />
                      <span id="label-for-twoColumn" class="ml-3">Two Column</span>
                    </label>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="row ahe-ui form-group mt-2 ml-2 no-margin">
                    <h3 id="spacingSectionHeading">Spacing between questions</h3>
                  </div>
                  <div class="ahe-ui-radio-list align-vertical" role="radiogroup" aria-labelledby="spacingSectionHeading">
                    <label class="ahe-ui-radio">
                      <input
                        type="radio"
                        id="narrowSpacing"
                        name="spacing"
                        value="narrow"
                        (change)="prefChanges($event)"
                        [(ngModel)]="spacePref"
                        aria-labelledby="label-for-narrowSpacing"
                      />
                      <span aria-hidden="true"></span>
                      <img
                        [src]="narrowSpaceImgUrl"
                        title="Narrow Space"
                        alt="Narrow Space"
                        class="ml-3"
                        aria-hidden="true"
                      />
                      <span id="label-for-narrowSpacing" class="ml-3">Narrow (2 Rows)</span>
                    </label>
                    <label class="ahe-ui-radio">
                      <input
                        type="radio"
                        id="wideSpacing"
                        name="spacing"
                        value="wide"
                        (change)="prefChanges($event)"
                        [(ngModel)]="spacePref"
                        aria-labelledby="label-for-wideSpacing"
                      />
                      <span aria-hidden="true"></span>
                      <img
                        [src]="wideSpaceImgUrl"
                        title="Wide Space"
                        alt="Wide Space"
                        class="ml-3"
                        aria-hidden="true"
                      />
                      <span id="label-for-wideSpacing" class="ml-3">Wide (3 Rows)</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3 mb-5 line-divider">
            <div class="mt-5 ml-1 fontSize18">
              <h2>Display</h2>
            </div>
            <div class="ml-1 ahe-ui form-group no-margin d-flex align-items-center flex-wrap">
              <label class="mb-2 mr-2" for="pageNumber">Page numbering starts at: <app-required-indicator [required]="true"></app-required-indicator></label>
              <input
                class="mr-2 mb-2 textWidth form-control"
                type="text"
                id="pageNumber"
                maxlength="5"
                [value]="pageNumber"
                (focusout)="validateNumber($event, 0)"
                aria-describedby="pageNumberHint"
                [required]="true"
              />
              <span id="pageNumberHint" class="input-hint mb-2 w-100">
                <span aria-hidden="true">(</span>Enter a value between 1 and 99999<span aria-hidden="true">)</span>
              </span>
            </div>
          </div>
          <div class="line-divider">
            <div class="mt-3 ml-1 pt-4 pb-4">
              <label class="mb-0" for="firstPageHeader">First page header</label>
              <small class="character-count" aria-live="polite" aria-atomic="true">
                ({{ firstHeaderCharLeft }} out of {{ maxHeaderLength }} characters remaining)
              </small>
            </div>
            <div class="ml-1 ahe-ui form-group">
              <textarea
                appTextareaResize
                [minHeight]="38"
                [resizeMode]="ResizeMode.VERTICAL"
                [attr.maxlength]="maxHeaderLength"
                id="firstPageHeader"
                class="ahe-ui-textarea form-control ml-lg-2 mb-lg-3 instructions-textarea"
                rows="3"
                (change)="prefChanges($event)"
                (input)="countCharacters($event)"
                [(ngModel)]="firstPageHeader"
                aria-describedby="resizeHint"
                >{{ firstPageHeader }}</textarea
              >
            </div>
            <div class="mt-3 ml-1 pt-4 pb-4">
              <label class="mb-0" for="otherPageHeader">Other page headers</label> 
              <small class="character-count" aria-live="polite" aria-atomic="true">
                ({{ secondHeaderCharLeft }} out of {{ maxHeaderLength }} characters remaining)
              </small>
            </div>
            <div class="ml-1 pb-4 ahe-ui form-group">
              <textarea
                appTextareaResize
                [minHeight]="38"
                [resizeMode]="ResizeMode.VERTICAL"
                [attr.maxlength]="maxHeaderLength"
                id="otherPageHeader"
                class="ahe-ui-textarea form-control ml-lg-2 mb-lg-3 instructions-textarea"
                rows="3"
                (change)="prefChanges($event)"
                (input)="countCharacters($event)"
                [(ngModel)]="otherPageHeader"
                aria-describedby="resizeHint"
                >{{ otherPageHeader }}</textarea
              >
            </div>
          </div>
          <div class="line-divider mb-5">
            <div class="mt-3 ml-1 mb-2 pt-4 no-margin">
              <label class="mb-0" for="instructions">Instructions</label>
            </div>
            <div class="ahe-ui form-group no-margin">
              <textarea
                appTextareaResize
                [minHeight]="38"
                [resizeMode]="ResizeMode.VERTICAL"
                maxlength="66"
                id="instructions"
                class="ahe-ui-textarea form-control ml-lg-2 mb-lg-3 instructions-textarea"
                rows="3"
                (change)="prefChanges($event)"
                [(ngModel)]="instructions"
                aria-describedby="resizeHint"
                >{{ instructions }}</textarea
              >
              <div class="sr-only" id="resizeHint">This text area can be resized vertically using Alt + Up and Alt + Down arrow keys.</div>
            </div>
          </div>
          <div
            class="pt-4 pb-5 line-divider"
            style="padding-left: 0"
          >
            <div class="ahe-ui mt-3 no-margin">
              <h2 id="displayQuestionTypeHeading">Display question type</h2>
            </div>
            <div role="group" aria-labelledby="displayQuestionTypeHeading">
              <div class="relative-top">
                <label class="ahe-ui-checkbox">
                  <input
                    type="checkbox"
                    id="questionSort"
                    [(ngModel)]="questionSort"
                    [value]="questionSort"
                    (click)="sortSelect($event)"
                    aria-labelledby="label-for-questionSort"
                  />
                  <span id="label-for-questionSort" class="cursor-pointer">Sort by question type</span>
                </label>
              </div>
              <div class="relative-top">
                <label class="ahe-ui-checkbox">
                  <input
                    type="checkbox"
                    id="displayQuestionTypeHeader"
                    [(ngModel)]="displayQuestionHeaderChecked"
                    [checked]="displayQuestionHeaderChecked"
                    [disabled]="questionTypeHeaderDisabled"
                    (change)="prefChanges($event)"
                    aria-labelledby="label-for-displayQuestionTypeHeader"
                  />
                  <span id="label-for-displayQuestionTypeHeader" class="cursor-pointer">Display question type header</span>
                </label>
              </div>
              <div
                class="relative-top ml-3"
                [hidden]="!displayQuestionHeaderChecked"
              >
                <button
                  class="ahe-ui-link cursor-pointer custom-underline-button link-style"
                  aria-haspopup="dialog"
                  (click)="showHeaderOrder()"
                  data-automation-id="customize-headers-and-order">
                  Customize headers and Order
                </button>
              </div>
            </div>
          </div>
          <div class="mt-3 line-divider">
            <div class="mt-5 ml-1">
              <h2 id="questionNumberHeading">Question number</h2>
            </div>
            <div class="ml-1 mb-2 ahe-ui form-group no-margin d-flex align-items-center flex-wrap">
              <label for="startQuestionNo" class="mr-2">Question number starts at: <app-required-indicator [required]="true"></app-required-indicator></label>
              <input
                class="mr-2 mb-2 textWidth form-control"
                type="text"
                id="startQuestionNo"
                maxlength="5"
                [value]="startQuestionNo"
                (focusout)="validateNumber($event, 0)"
                aria-describedby="startQuestionNoHint"
                [required]="true"
              />
              <span id="startQuestionNoHint" class="input-hint mb-2 w-100">
                <span aria-hidden="true">(</span>Enter a value between 1 and 99999<span aria-hidden="true">)</span>
              </span>
            </div>
          </div>
          <div
            class="mt-3 pb-5 line-divider"
            style="padding-left: 0"
          >
            <div class="relative-top mt-2 mb-3" style="margin-left: -5px">
              <label class="ahe-ui-checkbox d-block">
                <input
                  type="checkbox"
                  id="answerBlanks"
                  [(ngModel)]="answerBlanks"
                  [value]="answerBlanks"
                  (change)="prefChanges($event)"
                  aria-labelledby="label-for-answerBlanks"
                />
                <span class="cursor-pointer" id="label-for-answerBlanks"
                  >Show answer blanks for True/False, Multiple Choice and Check
                  All That Apply Question types</span
                >
              </label>
              <label class="ahe-ui-checkbox d-block">
                <input
                  type="checkbox"
                  id="questionInfo"
                  [(ngModel)]="questionInfo"
                  [value]="questionInfo"
                  (change)="prefChanges($event)"
                  aria-labelledby="label-for-questionInfo"
                  aria-describedby="description-for-questionInfo"
                />
                <span class="cursor-pointer" id="label-for-questionInfo">Show Question Detail</span>
                <div class="subtitle" id="description-for-questionInfo">
                  Example: Learning Objectives, Difficulty, Question Source
                </div>
              </label>
            </div>
            <div class="row mt-5">
              <div class="col">
                <div class="row ahe-ui form-group mt-3 ml-2 no-margin">
                  <strong id="tfSectionHeading">True/False</strong>
                </div>
                <div class="ahe-ui-radio-list align-vertical" role="radiogroup" aria-labelledby="tfSectionHeading">
                  <label class="ahe-ui-radio">
                    <input
                      type="radio"
                      id="tfbelowVertical"
                      name="tfAlignment"
                      value="Below-Vertical"
                      (change)="prefChanges($event)"
                      [(ngModel)]="tfAlignment"
                      aria-labelledby="label-for-tf-below-vertical"
                    />
                    <span id="label-for-tf-below-vertical">Below-vertical</span>
                    <div class="row mt-2">
                      <div class="col-sm-8 questionBar"></div>
                      <div
                        *ngIf="showAnswerBlanks"
                        class="col-sm-3 ml-3 answerBlanksBar"
                      ></div>
                    </div>
                    <div>
                      <div class="verticalDot"></div>
                      <div class="verticalBar"></div>
                    </div>
                    <div>
                      <div class="verticalDot"></div>
                      <div class="verticalBar"></div>
                    </div>
                    <div>
                      <div class="verticalDot"></div>
                      <div class="verticalBar"></div>
                    </div>
                  </label>
                  <label class="ahe-ui-radio mt-4">
                    <input
                      type="radio"
                      id="tfbelowHorizontal"
                      name="tfAlignment"
                      value="Below-Horizontal"
                      (change)="prefChanges($event)"
                      [(ngModel)]="tfAlignment"
                      aria-labelledby="label-for-tf-below-horizontal"
                    />
                    <span id="label-for-tf-below-horizontal">Below-horizontal</span>
                    <div class="row mt-2 padding-top-bottom">
                      <div class="col-sm-8 questionBar"></div>
                      <div
                        *ngIf="showAnswerBlanks"
                        class="col-sm-3 ml-3 answerBlanksBar"
                      ></div>
                    </div>
                    <div>
                      <div class="horizontalDot1"></div>
                      <div class="horizontalBar1"></div>
                      <div class="horizontalDot2"></div>
                      <div class="horizontalBar2"></div>
                      <div class="horizontalDot3"></div>
                      <div class="horizontalBar3"></div>
                    </div>
                  </label>
                </div>
              </div>
                <!-- Desktop vertical divider -->
                <div class="d-none d-md-block">
                  <hr />
                </div>
                
                <!-- Mobile horizontal divider -->
                <div class="col-12 d-md-none">
                  <hr />
                </div>
              <div class="col">
                    <div class="row ahe-ui form-group mt-3 ml-2 no-margin">
                      <strong id="mcSectionHeading">Multiple Choice / Check All</strong>
                    </div>
                    <div class="ahe-ui-radio-list align-vertical" role="radiogroup" aria-labelledby="mcSectionHeading">
                      <label class="ahe-ui-radio">
                        <input
                          type="radio"
                          id="mcbelowVertical"
                          name="mcCaAlignment"
                          value="Below-Vertical"
                          (change)="prefChanges($event)"
                          [(ngModel)]="mcCaAlignment"
                          aria-labelledby="label-for-mc-below-vertical"
                        />
                        <span id="label-for-mc-below-vertical">Below-vertical</span>
                        <div class="row mt-2">
                          <div class="questionBar"></div>
                          <div
                            *ngIf="showAnswerBlanks"
                            class="col-sm-3 ml-3 answerBlanksBar"
                          ></div>
                        </div>
                        <div>
                          <div class="verticalDot"></div>
                          <div class="verticalBar"></div>
                        </div>
                        <div>
                          <div class="verticalDot"></div>
                          <div class="verticalBar"></div>
                        </div>
                        <div>
                          <div class="verticalDot"></div>
                          <div class="verticalBar"></div>
                        </div>
                      </label>
                      <label class="ahe-ui-radio mt-4">
                        <input
                          type="radio"
                          id="mcbelowHorizontal"
                          [disabled]="disableBelowHorizontal"
                          name="mcCaAlignment"
                          value="Below-Horizontal"
                          (change)="prefChanges($event)"
                          [(ngModel)]="mcCaAlignment"
                          aria-labelledby="label-for-mc-below-horizontal"
                        />
                        <span id="label-for-mc-below-horizontal">Below-horizontal</span>
                        <div class="row mt-2 padding-top-bottom">
                          <div class="questionBar"></div>
                          <div
                            *ngIf="showAnswerBlanks"
                            class="col-sm-3 ml-3 answerBlanksBar"
                          ></div>
                        </div>
                        <div>
                          <div class="horizontalDot1"></div>
                          <div class="horizontalBar1"></div>
                          <div class="horizontalDot2"></div>
                          <div class="horizontalBar2"></div>
                          <div class="horizontalDot3"></div>
                          <div class="horizontalBar3"></div>
                        </div>
                      </label>
                </div>
              </div>
                <!-- Desktop vertical divider -->
                <div class="d-none d-md-block">
                  <hr />
                </div>
                <!-- Mobile horizontal divider -->
                <div class="col-12 d-md-none">
                  <hr />
                </div>
              <div class="col">
                    <div class="row ahe-ui form-group mt-3 ml-2 no-margin">
                      <strong id="saSectionHeading">Short Answer / Essay</strong>
                    </div>
                    <div class="ahe-ui-radio-list align-vertical" role="radiogroup" aria-labelledby="saSectionHeading">
                      <label class="ahe-ui-radio">
                        <input
                          type="radio"
                          id="saLines"
                          name="saEsPref"
                          value="lines"
                          (change)="prefChanges($event)"
                          [(ngModel)]="saEsPref"
                          aria-labelledby="label-for-sa-lines"
                        />
                        <span id="label-for-sa-lines">Lines</span>
                        <div class="row mt-2">
                          <div class="questionBar"></div>
                        </div>
                        <div>
                          <div class="saLines"></div>
                          <div class="saLines"></div>
                          <div class="saLines mt-3"></div>
                          <div class="saLines mt-3 mb-2"></div>
                        </div>
                      </label>
                      <label class="ahe-ui-radio mt-4">
                        <input
                          type="radio"
                          id="saBlanks"
                          name="saEsPref"
                          value="blank"
                          (change)="prefChanges($event)"
                          [(ngModel)]="saEsPref"
                          aria-labelledby="label-for-sa-blanks"
                        />
                        <span id="label-for-sa-blanks">Blanks</span>
                        <div class="row mt-2 padding-top">
                          <div class="questionBar"></div>
                        </div>
                        <div>
                          <div class="saBlanks"></div>
                        </div>
                      </label>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3 mb-5 line-divider">
            <div class="mt-4 ml-1">
              <h2 id="answerKeySectionHeading">Answer Key</h2>
            </div>
            <div class="ml-1 ahe-ui ahe-ui-radio-list form-group no-margin align-vertical" role="group" aria-labelledby="answerKeySectionHeading">
              <label class="ahe-ui-checkbox">
                <input
                  type="checkbox"
                  id="includeCommonFeedback"
                  name="includeCommonFeedback"
                  value="includeCommonFeedback"
                  (change)="prefChanges($event)"
                  [(ngModel)]="includeCommonFeedbackModel"
                  aria-labelledby="label-for-includeCommonFeedback"
                />
                <span id="label-for-includeCommonFeedback">Include common feedback</span>
              </label>
              <label class="ahe-ui-radio">
                <input
                  type="radio"
                  id="continuePageNo"
                  name="answerKeyPref"
                  value="continuePageNo"
                  (change)="prefChanges($event)"
                  [(ngModel)]="answerKeyPage"
                  aria-labelledby="label-for-continuePageNo"
                />
                <span id="label-for-continuePageNo">Continue page numbering</span>
              </label>
              <div class="d-flex align-items-center flex-wrap">
              <label class="ahe-ui-radio radio-label-margin">
                <input
                  type="radio"
                  id="restartPageNo"
                  name="answerKeyPref"
                  value="restartPageNo"
                  (change)="prefChanges($event)"
                  [(ngModel)]="answerKeyPage"
                  aria-labelledby="label-for-restartPageNo"
                />
                <span id="label-for-restartPageNo" class="mr-2">Restart page numbering at: <app-required-indicator [required]="!answerKeyPageNoDisabled"></app-required-indicator></span>
              </label>
                  <input
                    class="mb-2 textWidth form-control restart-page-number"
                    type="text"
                    id="answerKeyPageNo"
                    [disabled]="answerKeyPageNoDisabled"
                    maxlength="5"
                    [value]="answerKeyPageNo"
                    (focusout)="validateNumber($event, 0)"
                    aria-label="Restart page numbering at:"
                    aria-describedby="restartPageNoHint"
                    [required]="!answerKeyPageNoDisabled"
                  />
                  <span id="restartPageNoHint" class="input-hint mb-2 restart-page-number w-100">
                    <span aria-hidden="true">(</span>Enter a value between 1 and 99999<span aria-hidden="true">)</span>
                  </span>
              </div>
            </div>
          </div>

          <div class="mt-2 line-divider">
            <div class="mt-4 mb-1">
              <label class="ahe-ui-checkbox">
                <input
                  class="ml-1 mt-1 mb-1"
                  type="checkbox"
                  id="saveAsDefault"
                  [(ngModel)]="saveAsDefault"
                  [value]="saveAsDefault"
                  (change)="prefChanges($event)"
                  aria-labelledby="label-for-saveAsDefault"
                />
                <span class="cursor-pointer pt-4" id="label-for-saveAsDefault"
                  ><strong>Save these settings as default</strong></span
                >
              </label>
            </div>
            <div class="mt-1 mb-4">
              <label class="ahe-ui-checkbox">
                <input
                  class="ml-1 mt-1 mb-4"
                  type="checkbox"
                  id="applyDefault"
                  [(ngModel)]="applyDefault"
                  [value]="applyDefault"
                  (change)="prefChanges($event)"
                  aria-labelledby="label-for-applyDefault"
                />
                <span class="cursor-pointer" id="label-for-applyDefault"
                  ><strong>Apply default settings</strong></span
                >
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <common-modal-component
    *ngIf="showHeaderPreferences"
    [size]="size"
    [disableConfirm]="reorderConfirmDisabled"
    [header]="modalHeader"
    (modalOk)="modalOkJob()"
    (modalCancel)="modalCancelJob()"
    #reOrderModal
  >
    <div id="header-order" class="col-lg-12 col-md-12 col-xl-12" (keydown.escape)="handleModalEscapeEvent($event)">
      <div class="row large-header">Set order for question type headers</div>
      <div class="row">Drag to set order</div>
      <div class="row mt-4 pr-4 pr-sm-0">
        <div
          id="header-container"
          cdkDropList
          (cdkDropListDropped)="onDrop($event)"
        >
          <ol class="list-unstyled" role="list">
            <li [id]="'header-types-' + i" *ngFor="let type of headerType; let i = index, last as isLast, first as isFirst" role="listitem"
              class="row question-row no-margin header-types" cdkDrag>
              <div class="p-all-0 col-1">
                {{ i + 1 }}
              </div>
              <div [ngClass]="{ 'rename-edit-icon': selectedIndex == i }" class="p-all-0 col-1">
                <span class="handles" cdkDragHandle>
                  <i [id]="'header-drag-icon-' + i" class="dpg-icon dpg-icon-movingtile"></i>
                </span>
              </div>
              <div *ngIf="selectedIndex !== i" [id]="'header-value-desc' + i" class="p-all-0 col-7 col-md-6 header-desc text-truncate">
                <span [title]="type.desc" class="text-truncate d-inline-block mw-100">
                  <span class="sr-only">{{ type.desc }}</span>
                  {{ type.desc }}
                </span>
              </div>
              <div *ngIf="selectedIndex == i" #renameField class="ahe-ui form-group p-all-0 col-7 col-md-6  header-desc">
                <label [for]="'header-value-' + i" class="sr-only">Rename question type header</label>
                <input #renameInput [id]="'header-value-' + i" class="form-control" placeholder="Question Type Header" type="text"
                  [(ngModel)]="type.desc" />
              </div>
              <div class="p-all-0 col-1 text-center">
                <button class="custom-icon-btn" (click)="moveQuestionHeaderUp(i)" #moveUpButton
                  [disabled]="isFirst" [attr.data-automation-id]="'move-question-up-' + i"
                  appTooltip="Move Up" [alternateAriaLabel]="'Move Up ' + type.desc" panelClass="fit-overlay">
                  <img src="assets/img/arrow-up.svg" alt="Move up icon">
                </button>
              </div>
              <div class="p-all-0 col-1 text-center">
                <button class="custom-icon-btn" (click)="moveQuestionHeaderDown(i)" #moveDownButton
                  [disabled]="isLast" [attr.data-automation-id]="'move-question-down-' + i"
                  appTooltip="Move Down" [alternateAriaLabel]="'Move Down ' + type.desc" panelClass="fit-overlay">
                  <img src="assets/img/arrow-down.svg" alt="Move down icon">
                </button>
              </div>
              <div [id]="'header-rename-text-' + i" class="p-all-0 col-1 col-md-2">
                <div (click)="editHeader(i, type)">
                  <button class="rename-button p-2 d-none d-sm-block" [attr.aria-label]="'Rename ' + type.desc">Rename</button>
                  <button class="custom-icon-btn btn-rename d-block d-sm-none" [alternateAriaLabel]="'Rename ' + type.desc" appTooltip="Rename" panelClass="fit-overlay">
                    <img src="assets/img/edit.svg" alt="Rename icon">
                  </button>
                </div>
              </div>
            </li>
          </ol>
          <div class="sr-only" role="status">{{ reOrderAnnouncement }}</div>
        </div>
      </div>
    </div>
  </common-modal-component>

  <app-shared-modal
    titleText="Default settings change alert!"
    [isOpen]="settingsChanged"
    confirmButtonText="Confirm"
    cancelButtonText="Cancel"
    (close)="cancelSettingsChange()"
    (cancel)="cancelSettingsChange()"
    (confirm)="confirmSettingsChange()"
  >
    <div>Would you like to update your existing default settings with these selections?</div>
  </app-shared-modal>
</div>